import { NgModule } from '@angular/core';
import {
  Routes,
  RouterModule,
  PreloadAllModules
} from '@angular/router';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { DDFeatureConfigService } from './shared/service/common/dd-feature-config.service';
import { DDFeatureConfigServiceModule  } from './shared/service/dd-feature-config-service.module';
//
// Service Module
//
import { ddServiceModule } from './shared/service/dd-service.module';

const routes: Routes = [
  { path: '', redirectTo: '/v-spec', pathMatch: 'full' },
  {
    path: 'v-spec',
    loadChildren: () => import('./features/v-spec/v-spec.module').then(m => m.VSpecModule)
  },
  {
    path: 'v-spec/public',
    loadChildren: () => import('./features/v-spec/v-spec.module').then(m => m.VSpecModule)
  },
  {
    path: 'vehicles/:token',
    loadChildren: () => import('./features/vehicles/vehicles.module').then(m => m.VehiclesModule)
  },
  { path: 'not-found', component: PageNotFoundComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    ddServiceModule.forRoot(),
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    DDFeatureConfigServiceModule.forRoot()
  ],
  exports: [RouterModule],
  providers: [
    DDFeatureConfigService
  ]
})
export class AppRoutingModule {}

